// extracted by mini-css-extract-plugin
export var caption = "Media-module--caption--E8j6+";
export var playButton = "Media-module--playButton--5S9k7";
export var poster = "Media-module--poster--kIIAX";
export var videoWrapper = "Media-module--videoWrapper--pM0Yr";
export var wrapper = "Media-module--wrapper--rhdc-";